import React, { useEffect, useState } from "react";
import { RightOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Switch } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as Tick } from "../../../../assets/Icons/tick.svg";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { menulist } from "./data";
import PostUpdateData from "../../../../hooks/postUpdate";
import { useForm } from "antd/es/form/Form";

const Styleddiv = styled.div`
  table {
    width: 100%;
    margin: 20px 0;
    font-size: 16px;
    border-collapse: separate; /* Important for border-radius to work */
    border-spacing: 0; /* Prevent spacing between table cells */
    border-radius: 8px; /* Add border-radius to the table */
    overflow: hidden;
    border: 1px solid #e2e2e8;
  }
  th,
  td {
    border-left: 1px solid #e2e2e8;
    padding: 10px;
  }

  th {
    background-color: #f9f9f9;
    font-size: 16px;
    font-weight: 500;
    border: 1px solid #e2e2e8;
  }
  th:nth-child(2),
  td:nth-child(2),
  th:nth-child(3),
  td:nth-child(3),
  th:nth-child(4),
  td:nth-child(4),
  th:nth-child(5),
  td:nth-child(5) {
    width: 15%;
    text-align: center;
  }

  .parent-row {
    font-weight: bold;
  }

  input[type="checkbox"] {
    margin-right: 10px;
  }

  tbody tr:nth-child(even) {
    background-color: #f9f9f9; /* Light gray */
  }

  tbody tr:nth-child(odd) {
    background-color: #ffffff; /* White */
  }

  .subrow {
    color: #636980;
    font-size: 14px;
    font-weight: 400;
  }

  .border {
    border-radius: 8px;
    overflow: hidden;
  }

  .people-type {
    cursor: pointer;
    font-size: 16px;
    font-weight: normal;
    text-align: left;
    color: #636980;
  }

  .creating-people-type {
    font-size: 16px;
    font-weight: normal;
    text-align: left;
    color: #1f243b;
  }

  .name-text {
    font-size: 14px;
    font-weight: 500;
    color: #636980;
  }

  .permission-text {
    font-size: 16px;
    font-weight: 400;
    color: #1f243b;
    text-align: left;
  }

  .button-style {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 80%;
    margin-left: 271px;
    background-color: white;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    padding: 20px;
    padding-top: 20px;
    box-shadow: 0px -1px 5px rgba(0, 0, 0, 0.2);
  }

  .full-button-style {
    margin-left: 70px;
    position: fixed;
    bottom: 0;
    left: 0;
    width: calc(100% - 70px);
    background-color: white;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    padding: 20px;
    padding-top: 20px;
    box-shadow: 0px -1px 5px rgba(0, 0, 0, 0.2);
  }

  .cancel-button {
    width: 130px;
    height: 34px;
    border: 1px solid #1f243b;
    border-radius: 8px;
    transition: none !important;
  }

  .create-button {
    background-color: #c2fae5;
    width: 130px;
    height: 34px;
    border-radius: 8px;
    color: black;
    transition: none !important;
  }

  .cancel-button:hover,
  .cancel-button:active {
    border: 1px solid #1f243b !important;
    color: #1f243b !important;
  }

  .create-button:hover,
  .create-button:active {
    background-color: #c2fae5 !important;
    color: #1f243b !important;
  }

  .ant-switch-checked {
    background-color: #03c83e !important; /* Green color */
  }
`;
const CreatingPeopleType = ({ handleGetPeopleData }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isEditMode = queryParams.get("mode") === "edit";
  const editedRecord = location.state?.record;
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const isSideBarCollapsed = useSelector(
    (state) => state.systemTracking.isSideBarCollapsed
  );
  const getCreateAllPeopleType = useSelector(
    (state) => state.systemTracking.getCreateAllPeopleType
  );
  const userInfo = useSelector((state) => state.authTracking.userInfo);
  const [modalMessage, setModalMessage] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [saving, setSaving] = useState(false);

  const [groups, setGroups] = useState(
    isEditMode ? [editedRecord] : [menulist]
  );

  useEffect(() => {
    if (editedRecord) {
      form.setFieldsValue({ Name: editedRecord.name });
    }
  }, [form, editedRecord]);

  // Guard: if someone lands on ?mode=edit without a record in location.state
  // (e.g. page refresh, or direct URL nav), bounce back instead of rendering
  // a broken form with an undefined editedRecord.
  useEffect(() => {
    if (isEditMode && !editedRecord) {
      navigate("/settings-people", { state: { activeKey: "2" } });
    }
  }, [isEditMode, editedRecord, navigate]);

  const [visibleGroups, setVisibleGroups] = useState({
    Administrator: false,
    Tutor: false,
    Learner: false,
  });

  // Seeds which role sections start expanded when editing an existing
  // People Type. This used to depend on `groups` too, so it re-ran after
  // every single toggle (every switch click calls setGroups) and
  // immediately overwrote the switch you'd just clicked back to the
  // original record's value - "toggle buttons not working" was this
  // effect fighting the click on every render. It only needs to run once,
  // when the record we're editing first loads.
  useEffect(() => {
    if (editedRecord) {
      const updatedGroups = { ...visibleGroups };

      Object.keys(updatedGroups).forEach((role) => {
        const lowerCaseRole = role.toLowerCase();
        const roleData = editedRecord[lowerCaseRole];

        if (roleData?.status !== undefined) {
          updatedGroups[role] = roleData.status;
        }
      });
      setVisibleGroups(updatedGroups);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editedRecord]);

  const toggleVisibility = (groupName, role) => {
    const formatRole = role.charAt(0).toUpperCase() + role.slice(1);

    setVisibleGroups((prevState) => ({
      ...prevState,
      [formatRole]: !prevState[formatRole],
      [groupName]: {
        ...prevState[groupName],
        [role]: !prevState[groupName]?.[role],
      },
    }));

    setGroups((prevState) => {
      const group = prevState?.find((group) => group.name === groupName);

      if (!group) {
        return prevState;
      }

      const roleData = group[role]?.status;

      if (roleData === undefined) {
        return prevState;
      }

      const updatedGroups = prevState.map((grp) => {
        if (grp.name !== groupName) return grp;

        return {
          ...grp,
          [role]: {
            ...grp[role],
            status: !grp[role].status,
          },
        };
      });

      return updatedGroups;
    });
  };

  const toggleSubNamePermissions = (
    groupName,
    role,
    rowIndex,
    subIndex,
    permissionType
  ) => {
    setGroups((prevGroups) =>
      prevGroups?.map((group) => {
        if (group.name !== groupName) return group;

        const roleData = group[role][role];
        return {
          ...group,
          [role]: {
            ...group[role],
            [role]: roleData.map((menu, idx) => {
              if (idx !== rowIndex) return menu;

              if (!menu.subMenu.length) return menu;

              // If no permissionType provided, toggle all permissions for all subitems
              if (!permissionType) {
                const currentState = menu.subMenu[0]?.permission.view || false;
                const newState = !currentState;

                return {
                  ...menu,
                  subMenu: menu.subMenu.map((subItem) => ({
                    ...subItem,
                    permission: {
                      view: newState,
                      create: newState,
                      edit: newState,
                      delete: newState,
                    },
                  })),
                };
              }

              // Handle individual permission toggles
              return {
                ...menu,
                subMenu: menu.subMenu.map((subItem, sIdx) => {
                  if (sIdx !== subIndex && subIndex !== undefined)
                    return subItem;

                  let newPermissions = {
                    ...subItem.permission,
                    [permissionType]: !subItem.permission[permissionType],
                  };

                  if (permissionType === "view" && !newPermissions.view) {
                    newPermissions = {
                      view: false,
                      create: false,
                      edit: false,
                      delete: false,
                    };
                  }

                  return {
                    ...subItem,
                    permission: newPermissions,
                  };
                }),
              };
            }),
          },
        };
      })
    );
  };

  const roles = ["administrator", "tutor", "learner"];

  const togglePermission = (group, menuName, permissionType, role) => {
    setGroups((prevGroups) =>
      prevGroups?.map((grp) => {
        if (grp.name !== group.name) return grp;

        const roleData = grp[role]?.[role] || [];

        return {
          ...grp,
          [role]: {
            ...grp[role],
            [role]: roleData.map((menu) => {
              if (menu.menuName !== menuName) return menu;

              const currentPermissions = menu.permission || {
                view: false,
                create: false,
                edit: false,
                delete: false,
              };

              const updatedPermission = !currentPermissions[permissionType];

              if (permissionType === "view" && !updatedPermission) {
                return {
                  ...menu,
                  permission: {
                    view: false,
                    create: false,
                    edit: false,
                    delete: false,
                  },
                };
              }

              return {
                ...menu,
                permission: {
                  ...currentPermissions,
                  [permissionType]: updatedPermission,
                },
              };
            }),
          },
        };
      })
    );
  };

  // This is the ONLY save path now — triggered by the form's onFinish, which
  // fires when the submit button (htmlType="submit") is clicked and
  // validation passes. It handles both create and edit via isEditMode.
  const handlePostPeopleData = async (values) => {
    const singleObject = groups.reduce(
      (acc, curr) => ({ ...acc, ...curr }),
      {}
    );
    const payload = {
      ...singleObject,
      name: values.Name,
    };

    const endPoint = isEditMode
      ? `/settings/updateusertype/${userInfo.clientId}/${editedRecord.usertype_id}`
      : `/settings/addusertype/${userInfo.clientId}`;

    const method = isEditMode ? "PATCH" : "POST";

    setSaving(true);
    try {
      const response = await PostUpdateData({
        endPoint,
        method,
        obj: payload,
      });
      if (
        response?.statusCode === 200 ||
        response?.statusCode === 201 ||
        response?.status === 200 ||
        response?.status === 201
      ) {
        setModalMessage(isEditMode ? "Saved" : "Created");
        setIsModalVisible(true);
        setTimeout(() => {
          setIsModalVisible(false);
          navigate("/settings-people", { state: { activeKey: "2" } });
        }, 2000);
        handleGetPeopleData?.();
      } else {
        setModalMessage("Error occurred");
        setIsModalVisible(true);
        setTimeout(() => {
          setIsModalVisible(false);
        }, 2000);
      }
    } catch (error) {
      console.error("Error while creating:", error);
      setModalMessage("Error occurred");
      setIsModalVisible(true);
      setTimeout(() => {
        setIsModalVisible(false);
      }, 2000);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Styleddiv>
      <div className="mb-[2rem]">
        <div className="flex text-left gap-3">
          <p
            onClick={() => {
              navigate("/settings-people", { state: { activeKey: "2" } });
            }}
            className="people-type"
          >
            People Type
          </p>
          <RightOutlined className=" h-[24px]" />
          <p className="creating-people-type">
            {isEditMode ? "Editing People Type" : "Creating People Type"}
          </p>
        </div>
        <br />
        <div>
          <Form
            form={form}
            name="custom-form"
            layout="vertical"
            onFinish={handlePostPeopleData}
          >
            <Form.Item
              name="Name"
              label={<span className="name-text">Name</span>}
              rules={[
                {
                  required: true,
                  message: "Please enter the name",
                },
              ]}
              style={{ textAlign: "left" }}
            >
              <Input />
            </Form.Item>

            <div>
              <div className="permission-text">Permission</div>
              <table style={{ width: "100%" }}>
                <thead className="multi_table_header">
                  <tr>
                    <th rowSpan="2" colSpan="2" className="text-left">
                      Menu Access Level
                    </th>
                    <th>Read</th>
                    <th rowSpan="1" colSpan="3">
                      Write
                    </th>
                  </tr>
                  <tr>
                    <th className="text-center">View</th>
                    <th>Create</th>
                    <th>Modify</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {groups?.length === 0 && (
                    <td colSpan="6">
                      <p className="py-3">No Data Found</p>
                    </td>
                  )}
                  {groups?.length > 0 &&
                    groups?.map((group) => (
                      <React.Fragment key={group.name}>
                        {roles.map((role) => (
                          <React.Fragment key={`${group.name}-${role}`}>
                            <tr className="parent-row">
                              <td colSpan="6" className="parent-row">
                                <div className="flex gap-3 text-left">
                                  <span
                                    className="!w-[14%]"
                                    style={{
                                      color: "#636980",
                                      fontSize: "14px",
                                      fontWeight: 400,
                                    }}
                                  >
                                    {group[role]?.name}
                                  </span>
                                  <Switch
                                    checked={
                                      visibleGroups[
                                        role.charAt(0).toUpperCase() +
                                          role.slice(1)
                                      ]
                                    }
                                    onChange={() =>
                                      toggleVisibility(group.name, role)
                                    }
                                  />
                                </div>
                              </td>
                            </tr>

                            {visibleGroups[
                              role.charAt(0).toUpperCase() + role.slice(1)
                            ] && (
                              <tr key={`${group.name}-${role}-data`}>
                                <td colSpan="6">
                                  <table className="!mt-0">
                                    {group[role]?.[role]?.map(
                                      (menu, rowIndex) => (
                                        <React.Fragment key={rowIndex}>
                                          {menu.subMenu.length === 0 ? (
                                            <tr>
                                              <td
                                                className="text-left"
                                                style={{
                                                  color: "#636980",
                                                  fontSize: "14px",
                                                  fontWeight: 400,
                                                }}
                                              >
                                                {menu.menuName}
                                              </td>
                                              <td>
                                                <Switch
                                                  checked={menu.permission.view}
                                                  onChange={() =>
                                                    togglePermission(
                                                      group,
                                                      menu.menuName,
                                                      "view",
                                                      role
                                                    )
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <Switch
                                                  checked={
                                                    menu.permission.create
                                                  }
                                                  onChange={() =>
                                                    togglePermission(
                                                      group,
                                                      menu.menuName,
                                                      "create",
                                                      role
                                                    )
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <Switch
                                                  checked={menu.permission.edit}
                                                  onChange={() =>
                                                    togglePermission(
                                                      group,
                                                      menu.menuName,
                                                      "edit",
                                                      role
                                                    )
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <Switch
                                                  checked={
                                                    menu.permission.delete
                                                  }
                                                  onChange={() =>
                                                    togglePermission(
                                                      group,
                                                      menu.menuName,
                                                      "delete",
                                                      role
                                                    )
                                                  }
                                                />
                                              </td>
                                            </tr>
                                          ) : (
                                            <React.Fragment>
                                              <tr className="!border-0">
                                                <td
                                                  colSpan="5"
                                                  className="!border-0"
                                                >
                                                  <div className="flex gap-3 items-center text-left">
                                                    <p
                                                      className="!w-[10%]"
                                                      style={{
                                                        color: "#636980",
                                                        fontSize: "14px",
                                                        fontWeight: 400,
                                                      }}
                                                    >
                                                      {menu.menuName ||
                                                        "Sub Menu"}
                                                    </p>
                                                    <Switch
                                                      onChange={() =>
                                                        toggleSubNamePermissions(
                                                          group.name,
                                                          role,
                                                          rowIndex
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td
                                                  colSpan="5"
                                                  className="!border-0"
                                                >
                                                  <table className="!m-0">
                                                    {menu.subMenu.map(
                                                      (subItem, subIndex) => (
                                                        <tr key={subIndex}>
                                                          <td
                                                            className="text-left"
                                                            style={{
                                                              color: "#636980",
                                                              fontSize: "14px",
                                                              fontWeight: 400,
                                                            }}
                                                          >
                                                            {subItem.menuName}
                                                          </td>
                                                          <td>
                                                            <Switch
                                                              checked={
                                                                subItem
                                                                  .permission
                                                                  .view
                                                              }
                                                              onChange={() =>
                                                                toggleSubNamePermissions(
                                                                  group.name,
                                                                  role,
                                                                  rowIndex,
                                                                  subIndex,
                                                                  "view"
                                                                )
                                                              }
                                                            />
                                                          </td>
                                                          <td>
                                                            <Switch
                                                              checked={
                                                                subItem
                                                                  .permission
                                                                  .create
                                                              }
                                                              onChange={() =>
                                                                toggleSubNamePermissions(
                                                                  group.name,
                                                                  role,
                                                                  rowIndex,
                                                                  subIndex,
                                                                  "create"
                                                                )
                                                              }
                                                            />
                                                          </td>
                                                          <td>
                                                            <Switch
                                                              checked={
                                                                subItem
                                                                  .permission
                                                                  .edit
                                                              }
                                                              onChange={() =>
                                                                toggleSubNamePermissions(
                                                                  group.name,
                                                                  role,
                                                                  rowIndex,
                                                                  subIndex,
                                                                  "edit"
                                                                )
                                                              }
                                                            />
                                                          </td>
                                                          <td>
                                                            <Switch
                                                              checked={
                                                                subItem
                                                                  .permission
                                                                  .delete
                                                              }
                                                              onChange={() =>
                                                                toggleSubNamePermissions(
                                                                  group.name,
                                                                  role,
                                                                  rowIndex,
                                                                  subIndex,
                                                                  "delete"
                                                                )
                                                              }
                                                            />
                                                          </td>
                                                        </tr>
                                                      )
                                                    )}
                                                  </table>
                                                </td>
                                              </tr>
                                            </React.Fragment>
                                          )}
                                        </React.Fragment>
                                      )
                                    )}
                                  </table>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>

            <br />
            <div
              className={
                isSideBarCollapsed ? "full-button-style" : "button-style"
              }
            >
              <Button
                className="cancel-button"
                onClick={() => {
                  navigate("/settings-people", { state: { activeKey: "2" } });
                }}
              >
                Cancel
              </Button>
              <Button
                className="create-button"
                type="primary"
                htmlType="submit"
                loading={saving}
                disabled={saving}
              >
                {isEditMode ? "Save" : "Create"}
              </Button>
            </div>
          </Form>
        </div>
      </div>
      <Modal
        width={180}
        height={100}
        open={isModalVisible}
        footer={null}
        closable={false}
        centered
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            fontSize: "16px",
            fontWeight: "500",
            textAlign: "center",
          }}
        >
          <Tick style={{ width: "34px", height: "34px" }} />
          <p
            style={{
              fontSize: "16px",
              fontWeight: 400,
            }}
          >
            {modalMessage}
          </p>
        </div>
      </Modal>
    </Styleddiv>
  );
};

export default CreatingPeopleType;